import type { BindingType } from './binding.js';

// Human-readable mappings for the internal enum codes that flow through the
// store: brand/product/bundle/bindingType. The /licenses dashboard, /cart, and
// the SKU detail page render these labels rather than the raw codes; the
// catalog seed (local-server.v1SeedSkus) uses the same mappings for its
// displayName + description copy so the UI is consistent end-to-end.
//
// Bundle labels match the canonical names z9main publishes -- the license
// filenames carry them verbatim (z9/build.brand.z9security.gradle:
// z9open_azure_access.license, z9open_zkteco_atlas.license), and the
// swagger comments in z9flex-swagger-all.yaml describe these as "Z9 Open
// Apollo/Azure" + "Z9 Open ZKTeco USA Atlas Series". Use the canonical
// strings here so the shop is consistent with the rest of the product.

const PRODUCT: Record<string, string> = {
  Z9_WEB_APPLIANCE: 'Z9/Flex Server'
};

const BUNDLE: Record<string, string> = {
  Z9_APOLLO: 'Z9 Open Azure Access',
  Z9_ZKC5: 'Z9 Open ZKTeco USA Atlas Series',
  VIDEO_HANWHA_CAMERAS_10: 'Hanwha video (10 cameras)',
  VIDEO_MILESTONE_CAMERAS_8: 'Milestone video (8 cameras)'
};

const BRAND: Record<string, string> = {
  z9security: 'Z9 Security',
  zkteco: 'ZKTeco USA',
  apollo: 'Apollo (Azure)',
  mdi: 'iTRUST'
};

const BINDING_TYPE: Record<BindingType, string> = {
  FINGERPRINT_HEX: 'System fingerprint',
  MAC_ADDRESS: 'MAC address',
  NODE_UUID: 'Node UUID'
};

// Falling back to the raw code (rather than throwing) keeps the UI safe
// when a new enum value lands in z9main before the store ships a matching
// label -- the dashboard renders the code instead of crashing.
export function productLabel(code: string): string {
  return PRODUCT[code] ?? code;
}
export function bundleLabel(code: string): string {
  return BUNDLE[code] ?? code;
}
export function brandLabel(code: string): string {
  return BRAND[code] ?? code;
}
export function bindingTypeLabel(type: BindingType): string {
  return BINDING_TYPE[type];
}
